import React, { Component } from 'react';
import {
  LocalShippingIcon
} from "../bundles/IconsBundle";
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from "@material-ui/core/Typography";
import { DoSync, ReportProgress } from "../actions/SyncActions";
import { SetPrivilegedUser } from "../actions/SettingsActions";
import { connect } from 'react-redux';
import { Button } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import { setTitle } from "../actions/AppActions";
import { Text } from '../extensions/LangaugeContainer';

const styles = {
  // truck: {
  //   color: "#FFFFFF",
  //   position:'fixed',
  //   top:"45%",
  //   align: "center"
  // },
  // loader:{
  //   top: "55%",
  //   left: "20%",
  //   width: "60%",
  //   position: "apsolute"
  // },
  // loaderStyle:{
  //   colorPrimary: '#FFFFFF',
  //   colorSecondary: '#00B0DE',
  //   animationDuration: '2550ms',
  // },
  cont: {
    height: "calc(100vh - 56px)",
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 0,
    backgroundColor: "#00B0DE",
  }
}

class Sync extends Component {

  componentDidMount(){
    this.props.setTitle(<Text tid="synchronize"/>);
  }

  DoSync = async () => {
    await this.props.DoSync(this.props.settings, this.props.ReportProgress);

    this.props.SetPrivilegedUser(false);
   // this.moveToAuftrags();
  }

  moveToAuftrags = () => {
    window.location = '/';
  }

  render() {
   // console.log("Sync props: ", this.props);
    return <div style={styles.cont}>
      <div style={{ width: "100%", height: "40%" }}>
      </div>
      <div>
        <LocalShippingIcon style={{ fontSize: 44, color: "#FFFFFF" }} />
      </div >
      {this.props.sync.syncInProgress && (
        <div>
          <LinearProgress/>
          <br />
          <Typography component="div" style={{ color: "#FFFFFF", fontSize: 16 }}><Text tid="dbLoading"/>...</Typography>
        </div>
      )}
      <div>
        <Button
          style={{color:"#0080DE", backgroundColor:"#FFFFFF"}}
          variant="contained"
          onClick={this.DoSync}
        >
          <Text tid="sync"/>
                        </Button>
      </div>
      <ToastContainer autoClose={8000} />
    </div>

  }
}

const mapStateToProps = state => ({
  settings: state.settings,
  sync: state.sync
});

export default connect(mapStateToProps, { DoSync, ReportProgress, setTitle, SetPrivilegedUser })(Sync);